import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapViewComponent } from './components/map-view/map-view.component';
import { TripViewCabComponent } from './components/trip-view-cab/trip-view-cab.component';
import { TripDetailsCardComponent } from './components/trip-details-card/trip-details-card.component';
import { TripEmployeeCardComponent } from './components/trip-employee-card/trip-employee-card.component';
import { ToolTipModule } from "mis-crystal-design-system/tooltip";
import { AttendanceCabComponent } from './components/cards/attendance/attendance.component';
import { EmployeeCardComponent } from './components/cards/employee-card/employee-card.component';
import { EmployeesDetailsComponent } from './components/employees-details/employees-details.component';
import { MatTableModule } from '@angular/material/table';
import { TripInfoCardComponent } from './components/cards/trip-info-card/trip-info-card.component';
import { DeviceHealthComponentCab } from './components/device-health/device-health.component';
import { LoaderModule } from 'mis-crystal-design-system/loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'mis-crystal-design-system/modal';
import { SwitchModule } from 'mis-crystal-design-system/switch';
import { MatDialogModule } from '@angular/material/dialog';
import { DatepickerModuleV2 } from 'mis-crystal-design-system/datepicker_v2';
import { DropdownModule } from 'mis-crystal-design-system/dropdown';
import { RadioButtonModule } from 'mis-crystal-design-system/radio-button';
import { CabStopCardComponent } from './components/cards/cab-stop-card/cab-stop-card.component';
import { SideViewCabComponent } from './components/side-view/side-view.component';
import { CabStopTripTimelineComponent } from './components/cards/cab-trip-stop-timeline/cab-trip-stop-timeline.component';
import { TabFilterComponent } from './components/map-view/tab-filter/tab-filter.component';
import { CapitalCasePipe } from './components/cards/trip-info-card/capital-case.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from 'src/shared/shared.module';
@NgModule({
  declarations: [
    MapViewComponent,
        SideViewCabComponent,
        TripViewCabComponent,
        TripDetailsCardComponent,
        TripEmployeeCardComponent,
        AttendanceCabComponent,
        CabStopCardComponent, 
        EmployeeCardComponent,
        EmployeesDetailsComponent,
        TripInfoCardComponent,
        DeviceHealthComponentCab,
        CabStopTripTimelineComponent,
  ],
  imports: [
    CommonModule,
    ToolTipModule.forRoot(),
    MatTableModule,
    LoaderModule,
    FormsModule,
    CommonModule,
    BrowserAnimationsModule,
    ModalModule,
    BrowserAnimationsModule,
    SwitchModule,
    MatDialogModule,
    DatepickerModuleV2,
    DropdownModule,
    RadioButtonModule,
    ReactiveFormsModule,
    TabFilterComponent,
    CapitalCasePipe,
    MatTooltipModule,
    ScrollingModule,
    SharedModule
  ],
  exports: [ 
    SideViewCabComponent,
    TripViewCabComponent,
    TripDetailsCardComponent,
    TripEmployeeCardComponent,
    AttendanceCabComponent,
    CabStopCardComponent, 
    EmployeeCardComponent,
    EmployeesDetailsComponent,
    TripInfoCardComponent,
    DeviceHealthComponentCab,
    CabStopTripTimelineComponent],
})
export class TripViewCabModule
{

}